<div class="ap-email">
    <div class="ap-email-section-header">
        <p class="ap-section-label">{{ section.label }}</p>
        <flex-spacer></flex-spacer>
        <button
            *ngIf="section.editable && !inEditMode"
            type="button"
            class="ap-email-edit-button"
            (click)="enterEditMode()">
            Edit
        </button>
    </div>

    <!-- READ-ONLY PANEL -->
    <div class="ap-email-card" *ngIf="!inEditMode">
        <div class="ap-email-header">
            <span class="ap-email-subject">{{ displaySubject }}</span>
        </div>

        <div class="ap-email-body-panel">
            <div class="ap-email-body" [innerHTML]="displayBody"></div>
        </div>

        <p class="ap-email-footnote" *ngIf="section.footnote">
            <i class="ph-bold ph-info icon-muted icon-12" aria-hidden="true"></i>
            <span [innerHTML]="section.footnote.text"></span>
        </p>
    </div>

    <!-- EDIT FORM -->
    <div class="ap-email-card ap-email-edit" *ngIf="inEditMode" [formGroup]="form">
        <div class="ap-email-edit-body">
            <label class="ap-email-edit-label" for="ap-email-subject-input">Subject</label>
            <input
                id="ap-email-subject-input"
                type="text"
                class="ap-email-subject-input"
                formControlName="subject"
                aria-label="Subject" />

            <label class="ap-email-edit-label">Message</label>
            <!--
              type="compact" intentionally — `type="email"` has a hard-coded
              ngOnInit that overwrites the form value with `Hi {first_name},`
              every time the editor instantiates, which would clobber the
              real body whenever the user clicks Edit.
            -->
            <app-rich-text-editor
                [formGroup]="$any(form)"
                controlName="body"
                type="compact"
                [useNewStyles]="true"
                [isLoading]="false"
                placeholder="Write the email body…"
                [additionalInsertFields]="['first_name']">
            </app-rich-text-editor>
        </div>

        <div class="ap-email-edit-actions">
            <button
                type="button"
                mat-flat-button
                [disableRipple]="true"
                color="accent"
                class="ap-email-edit-cancel"
                (click)="cancelEdit()">
                Cancel
            </button>
            <flex-spacer></flex-spacer>
            <button
                type="button"
                mat-flat-button
                [disableRipple]="true"
                color="primary"
                (click)="saveEdit()">
                <i class="ph-bold ph-check icon-white icon-16" aria-hidden="true"></i>
                Save changes
            </button>
        </div>
    </div>
</div>
